var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(this.product)?_c('product-form',{staticClass:"mb-5 pa-2",attrs:{"model":this.product},on:{"saved":_vm.saved}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }